<template>
	<v-container style="max-width: 1200px;">
		<v-sheet class="mt-10">
			<v-img :src="require('@/assets/banner-jet-aghsat.jpg')" class="rounded-xl"></v-img>
		</v-sheet>

		<v-row class="mt-10">
			<v-col cols="12" md="6">
				<div class="section-title mb-5">
					<h3 class="fs-h4">معرفی نرم افزار</h3>
					<h1 class="orange--text text--darken-2 ff-emkan-bold fs-h3">نرم افزار تحت وب مدیریت وام و اقساط ویژه اصناف</h1>
				</div>
				<p class="text--primary text-justify line-height-2d5">
					نرم افزار تحت وب مدیریت اقساط ویژه کلیه اصنافی است که خدمات یا کالای اقساطی به مشتریان خود ارائه می کنند و بدنبال ابزار آنلاینی هستند که از هر کجا بتوانند اقساط مشتریان و وضعیت کلی صندوق و بانک خود را مدیریت کنند.
				</p>
				<v-list nav dense>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon class="grey lighten-1" dark>
								mdi-check
							</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title class="ff-emkan-bold fs-h5">مناسب مغازه ها و فروشگاه ها</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon class="grey lighten-1" dark>
								mdi-check
							</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title class="ff-emkan-bold fs-h5">مناسب صندوق های وام</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon class="grey lighten-1" dark>
								mdi-check
							</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title class="ff-emkan-bold fs-h5">مناسب اشخاص</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-col>
			<v-col cols="12" md="6">
				<v-row>
					<v-col cols="12" md="6">
						<v-card elevation="8" class="rounded-xl">
							<div class="text-center py-5">
								<v-btn fab color="#36274C" elevation="1" large>
									<v-icon color="white">mdi-chart-arc</v-icon>
								</v-btn>
							</div>
							<v-card-title class="fs-h4 justify-center">داشبورد مدیریتی</v-card-title>
							<v-card-text class="text-center">مشاهده آمار و وضعیت کلی در یک نگاه</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="6">
						<v-card elevation="8" class="rounded-xl">
							<div class="text-center py-5">
								<v-btn fab color="#36274C" elevation="1" large>
									<v-icon color="white">mdi-account-group-outline</v-icon>
								</v-btn>
							</div>
							<v-card-title class="fs-h4 justify-center">لیست مشتریان</v-card-title>
							<v-card-text class="text-center">دسترسی سریع به پرونده مشتریان</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="6">
						<v-card elevation="8" class="rounded-xl">
							<div class="text-center py-5">
								<v-btn fab color="#36274C" elevation="1" large>
									<v-icon color="white">mdi-page-next-outline</v-icon>
								</v-btn>
							</div>
							<v-card-title class="fs-h4 justify-center">پنل مشتریان</v-card-title>
							<v-card-text class="text-center">پنل اختصاصی مشتریان</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="6">
						<v-card elevation="8" class="rounded-xl">
							<div class="text-center py-5">
								<v-btn fab color="#36274C" elevation="1" large>
									<v-icon color="white">mdi-chart-box-outline</v-icon>
								</v-btn>
							</div>
							<v-card-title class="fs-h4 justify-center">گزارش های کاربردی</v-card-title>
							<v-card-text class="text-center">پنل اختصاصی مشتریان</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" md="6">
				<v-sheet class="mt-10 pa-10 rounded-xl" color="#eee">
					<div>
						<v-img style="background-color: white;" :src="require('@/assets/sms-panel-bg.png')" class="rounded-xl"></v-img>
					</div>
					<div>
						<h3 class="orange--text text--darken-2 ff-emkan-bold fs-h3 text-center my-3">ارسال پیامک</h3>
					</div>
					<p class="text--primary text-justify line-height-2d5">
						مدیریت بخش پیامک ها با تنظیمات ‌کامل شامل موارد زیر:
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">ارسال پیامک های یادآوری پیش از موعد - روز سررسید - معوق - تشکر از پرداخت</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">تنظیم ساعت ارسال پیامک ها در روز</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">ایجاد قالب متن دلخواه برای پیامک ها</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">مشاهده لیست پیامک های مرتبط با هر قسط</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-sheet>
			</v-col>
			<v-col cols="12" md="6">
				<v-sheet class="mt-10 pa-10 rounded-xl" color="#eee">
					<div>
						<v-img :src="require('@/assets/online-payment.webp')" class="rounded-xl"></v-img>
					</div>
					<div>
						<h3 class="orange--text text--darken-2 ff-emkan-bold fs-h3 text-center my-3">درگاه پرداخت آنلاین</h3>
					</div>
					<p class="text--primary text-justify line-height-2d5">
						قابلیت اتصال پنل به درگاه بانکی برای واریز اقساط متشریان شامل موارد زیر:
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">انتخاب درگاه بانکی پیش فرض در تنظیمات سایت</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">درج لینک پرداخت در پیامک های یادآوری قسط</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">پرداخت آنلاین قسط توسط مشتری در پنل کاربران</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-sheet>
			</v-col>
		</v-row>

		<v-sheet class="mt-10 pa-10 rounded-xl" color="#eee">
			<v-row>
				<v-col cols="12" md="4">
					<v-img :src="require('@/assets/manage-loan.png')" class="rounded-xl"></v-img>
				</v-col>
				<v-col cols="12" md="8">
					<div class="section-title mb-5">
						<h3 class="orange--text text--darken-2 ff-emkan-bold fs-h3">تعیین بهره وام ها</h3>
					</div>
					<p class="text--primary text-justify line-height-2d5">
						ایجاد و تعریف مشخصات وام هایی که در کسب و کار خود دارید به صورت نامحدود، مثلا ممکن است سه نوع وام با بهره های مختلف را در روال کاری خود داشته باشید بنابراین می توانید در نرم افزار سه نوع وام مجزا تعریف کنید که هر کدام ویژگی های مختص خود را داشته باشد و در زمان ثبت یک وام برای مشتری تعیین کنید که از کدام نوع وام استفاده شود.
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">تعیین میزان درصد بهره در تعریف وام</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">تعیین میزان درصد دیرکرد و زود کرد در تعریف وام</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">محاسبه خودکار مبلغ قسط بر اساس میزان بهره وام و تعداد ماه های اقساط</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">محاسبه دیرکرد و زودکرد هر قسط تا روز جاری</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">محاسبه خودکار میزان مبلغ تسویه آنی</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
		</v-sheet>

		<v-sheet class="mt-10 pa-10 rounded-xl">
			<v-row>
				<v-col cols="12" md="8">
					<div class="section-title mb-5">
						<h3 class="orange--text text--darken-2 ff-emkan-bold fs-h3">لیست مشتریان و مشاهده پرونده هر مشتری</h3>
					</div>
					<p class="text--primary text-justify line-height-2d5">
						لیست مشتریان با قابلیت جستجوی سریع بر روی مشخصات فردی و شماره موبایل و غیره در اختیار شماست که به راحتی می توانید به اطلاعات مشتریان دسترسی پیدا کنید و با یک کلیک نیز به پرونده مشتری مورد نظر دسترسی پیدا کنید.
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">دریافت لیست مشتریان از فایل اکسل</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">جستجوی سریع بر اساس اطلاعات فردی و شماره موبایل و مبلغ قسط و غیره</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">تفکیک پذیری مشتریان تسویه شده و مشتریان فعال</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">قابلیت ثبت نحوه قسط پرداخت شده به صورت بانک، صندوق، درگاه آنلاین بانکی یا طلا</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
				<v-col cols="12" md="4">
					<v-img :src="require('@/assets/moavagh-list.jpg')" class="rounded-xl"></v-img>
				</v-col>
			</v-row>
		</v-sheet>

		<v-sheet class="mt-10 pa-10 rounded-xl" color="#eee">
			<v-row>
				<v-col cols="12" md="4">
					<v-img :src="require('@/assets/digi-marktng-broken.png')" class="rounded-xl"></v-img>
				</v-col>
				<v-col cols="12" md="8">
					<div class="section-title mb-5">
						<h3 class="orange--text text--darken-2 ff-emkan-bold fs-h3">داشبورد و گزارش ها</h3>
					</div>
					<p class="text--primary text-justify line-height-2d5">
						از آنجایی که مهمترین بخش یک نرم افزار ارائه اطلاعات و گزارش های کاربردی به مدیر آن مجموعه می باشد، نرم افزار مدیریت وام و اقساط نیز از این قاعده مستثنی نبوده و با در اختیار گذاشتن اطلاعات در بخش داشبورد سایت و بخش گزارشات شما را در تحلیل و مدیریت کسب و کار خود یاری می دهد.
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">ارائه آمار جامع از مجموع کلی وام ها و اقساط پرداخت شده و مانده در داشبورد</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">مشاهده لیست اقساط سررسید شده و معوق ها در داشبورد</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">قابلیت ثبت برداشت از بانک و صندوق و جعبه طلا در داشبورد</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">مشاهده لیست واریز و برداشت های بانک و صندوق و جعبه طلا و مشاهده مانده هر کدام</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">ارائه گزارش وام های مشتریان بر اساس بازه تاریخ</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">گزارش سررسید اقساط بر اساس تاریخ</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">گزارش واریزها بر اساس تاریخ</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
		</v-sheet>

		<v-sheet class="mt-10 pa-10 rounded-xl">
			<v-row>
				<v-col cols="12" md="8">
					<div class="section-title mb-5">
						<h3 class="orange--text text--darken-2 ff-emkan-bold fs-h3">پنل کاربری مختص مشتریان</h3>
					</div>
					<p class="text--primary text-justify line-height-2d5">
						هر مشتری می تواند با نام کاربری و کلمه عبوری که در اختیارش قرار داده می شود به پنل کاربری خود دسترسی داشته باشد و از ریز پرداخت ها و وضعیت اقساط خود مطلع شود.
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">مشاهده وام های اخذ شده و اطلاع از وضعیت کلی اقساط و پرداختی ها و مانده ها </v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">قابلیت پرداخت آنلاین اقساط</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">اعلام واریزی قسط های پرداخت شده</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<p class="text--primary text-justify line-height-2d5">
						در صورت استفاده نرم افزار توسط صندوق های وام، امکانات زیر قابل دسترس خواهد بود:
					</p>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">قابلیت ثبت پس انداز ماهانه برای اعضای صندوق</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">قابلیت ثبت درخواست وام توسط اعضای صندوق از پنل کاربری خود</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-avatar>
								<v-icon class="grey lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5">قابلیت ثبت هزینه های صندوق</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
				<v-col cols="12" md="4">
					<v-img :src="require('@/assets/member-panel.png')" class="rounded-xl"></v-img>
				</v-col>
			</v-row>
		</v-sheet>

		<v-sheet>
			<v-row>
				<v-col>
					<h3 class="fs-h3 text-center ff-emkan-bold orange--text">امکانات حرفه ای</h3>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="4">
					<v-card elevation="8" class="rounded-xl">
						<div class="text-center py-5">
							<v-btn fab color="#36274C" elevation="1" x-large>
								<v-icon color="white">mdi-monitor-speaker </v-icon>
							</v-btn>
						</div>
						<v-card-title class="fs-h4 justify-center">رابط کاربری حرفه ای</v-card-title>
						<v-card-text class="justify-center text-center">با رابط کاربری حرفه ای و مدرن</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" md="4">
					<v-card elevation="8" class="rounded-xl">
						<div class="text-center py-5">
							<v-btn fab color="#36274C" elevation="1" x-large>
								<v-icon color="white">mdi-speedometer</v-icon>
							</v-btn>
						</div>
						<v-card-title class="fs-h4 justify-center">ساده و سریع</v-card-title>
						<v-card-text class="text-center">مثل جت اجرا میشه در عین سادگی</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" md="4">
					<v-card elevation="8" class="rounded-xl">
						<div class="text-center py-5">
							<v-btn fab color="#36274C" elevation="1" x-large>
								<v-icon color="white">mdi-plane-car</v-icon>
							</v-btn>
						</div>
						<v-card-title class="fs-h4 justify-center">دسترسی از هر جا</v-card-title>
						<v-card-text class="text-center">از هر جا وارد نرم افزار خود شوید</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" md="4">
					<v-card elevation="8" class="rounded-xl">
						<div class="text-center py-5">
							<v-btn fab color="#36274C" elevation="1" x-large>
								<v-icon color="white">mdi-palette-outline</v-icon>
							</v-btn>
						</div>
						<v-card-title class="fs-h4 justify-center">قابلیت سفارش سازی</v-card-title>
						<v-card-text class="text-center">انجام تغییرات طبق نیاز شما</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" md="4">
					<v-card elevation="8" class="rounded-xl">
						<div class="text-center py-5">
							<v-btn fab color="#36274C" elevation="1" x-large>
								<v-icon color="white">mdi-face-agent</v-icon>
							</v-btn>
						</div>
						<v-card-title class="fs-h4 justify-center">پشتیبانی حرفه ای</v-card-title>
						<v-card-text class="text-center">با تیم حرفه ای از شما پشتیبانی می شود</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" md="4">
					<v-card elevation="8" class="rounded-xl">
						<div class="text-center py-5">
							<v-btn fab color="#36274C" elevation="1" x-large>
								<v-icon color="white">mdi-timer-refresh-outline</v-icon>
							</v-btn>
						</div>
						<v-card-title class="fs-h4 justify-center">مشاهده دمو</v-card-title>
						<v-card-text class="text-center">قبل از خرید تست کنید</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-sheet>

		<v-sheet color="#36274C" class="py-15 mt-15 px-5">
			<div style="max-width: 750px;" class="mx-auto mb-5">
				<div class="line-title">
					<span class="text">قیمت</span>
					<span class="line"></span>
				</div>
				<div class="mt-7">
					<v-row>
						<v-col cols="12" md="6">
							<div class="price-table">
								<div class="price-table__ribbon">
									<div class="price-table__ribbon-inner">
										تخفیف ویژه </div>
								</div>
								<div class="header">
									<div class="title-1">پرونده ای سالیانه</div>
									<div class="title-2">سرویس دهی به صورت ابری</div>
								</div>
								<div class="price">
									<div class="currency">هر پرونده</div>
									<div>{{ cloudPrice.toString().toPriceFormat() }}</div>
									<div class="currency">تومان</div>
								</div>
								<div class="features">
									<!-- <div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>۵ درصد تخفیف به ازا هر ۱۰۰ پرونده</span>
									</div> -->
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>اتصال به دامنه اختصاصی شما</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>اعتبار یکساله با پشتیبانی رایگان</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>ارسال پیامک</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>پرداخت آنلاین قسط توسط مشتری</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>۱۰ روز مهلت تست</span>
									</div>
									<div v-if="isAdmin" class="mt-5 pb-5 text-center">
										<v-btn dark color="orange" :loading="loading" @click="purchase(1)">
											ثبت خرید
										</v-btn>
									</div>
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="6">
							<div class="price-table">
								<div class="price-table__ribbon">
									<div class="price-table__ribbon-inner">
										تخفیف ویژه </div>
								</div>
								<div class="header">
									<div class="title-1">نامحدود سالیانه</div>
									<div class="title-2">سرویس دهی به صورت ابری</div>
									<!-- <div class="title-2">سرویس دهی بر روی هاست و دامنه اختصاصی</div> -->
								</div>
								<div class="price">
									<div class="currency">بدون محدودیت</div>
									<div>{{ permanentPrice.toString().toPriceFormat() }}</div>
									<div class="currency">تومان</div>
								</div>
								<div class="features">
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>اتصال به دامنه اختصاصی شما</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>اعتبار یکساله با پشتیبانی رایگان</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>ارسال پیامک</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>پرداخت آنلاین قسط توسط مشتری</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>۱۰ روز مهلت تست</span>
									</div>
									<!-- <div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>تغییرات طبق نیاز مشتری</span>
									</div> -->
									<div v-if="isAdmin" class="mt-5 pb-5 text-center">
										<v-btn dark color="orange" :loading="loading" @click="purchase(0)">
											ثبت خرید
										</v-btn>
									</div>
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="12">
							<div class="price-table">
								<div class="price-table__ribbon">
									<div class="price-table__ribbon-inner">
										تخفیف ویژه </div>
								</div>
								<div class="header">
									<div class="title-1">دائمی سفارشی</div>
									<div class="title-2">سرویس دهی به صورت غیر ابری</div>
								</div>
								<!-- <div class="price">
									<div class="currency">نامحدود</div>
									<div class="currency">قیمت: تماس با ما</div>
								</div> -->
								<div class="features">
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>نصب بر روی سرور یا هاست و دامنه اختصاصی شما</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>اعتبار نامحدود با پشتیبانی حرفه ای</span>
									</div>
									<div class="features-item">
										<v-icon class="ml-1">mdi-check-circle-outline</v-icon>
										<span>سفارشی سازی طبق نیاز شما</span>
									</div>
									<div v-if="isAdmin" class="mt-5 pb-5 text-center">
										<a href="https://jetafzaar.ir/تماس-با-ما/" target="_blank">
											<v-btn dark color="orange" :loading="loading">
												قیمت: تماس با فروش
											</v-btn>
										</a>
									</div>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
				<div class="line-title mt-7">
					<span class="text">قبل از خرید تست کنید</span>
					<span class="line"></span>
				</div>
				<div>
					<p class="text-justify white--text">
						قبل از خرید می توانید نرم افزار را تست و بررسی نمایید، جهت تست ابتدا شماره موبایل خود را در فرم زیر وارد کنید و پس از دریافت کلمه عبور بر روی دکمه رفتن به نرم افزار کلیک کنید و از شماره موبایل خود به عنوان نام کاربری و کلمه عبور پیامک شده جهت ورود به نرم افزار استفاده نمایید.
					</p>
					<div style="width: 300px;" class="mx-auto mb-5">
						<v-form ref="registerForm" class="" @submit.prevent="submitRegister">
							<v-row>
								<v-col cols="12" class="pb-0">
									<v-text-field ref="regName" dark v-model="reg.name" label="نام شخصی یا تجاری خود را وارد کنید" :error-messages="errorMessages" :rules="[(value) => !!value || 'نام را وارد کنید']" required />
								</v-col>

								<v-col cols="12" class="py-0">
									<v-text-field ref="regMobile" maxlength="11" dark v-model="reg.mobile" label="شماره موبایل خود را وارد کنید" :error-messages="errorMessages" :rules="[(value) => !!value || 'موبایل را وارد کنید', (value) => isPhoneNumberValid() || 'موبایل را به صورت صحیح وارد کنید']" required />
								</v-col>

								<v-col cols="12" class="text-center">
									<Countdown class="white--text fs-h3" @finish="countDownFinished" ref="countdown" />
									<v-btn v-if="sendCodeVisible" :loading="regLoading" block color="orange" dark type="submit" class="mb-2">دریافت کلمه عبور</v-btn>
									<div v-if="showLoginToAppBtn" class="white--text">پس از دریافت کلمه عبور، جهت ورود به نرم افزار <a href="" @click="loginToApp" class="orange--text">اینجا</a> کلیک کنید</div>
									<div v-show="regValidation" class="pink pa-2 mt-2">
										{{ regValidation }}
									</div>
								</v-col>

							</v-row>
						</v-form>
					</div>
				</div>
				<div class="line-title mt-7">
					<span class="text">نحوه خرید</span>
					<span class="line"></span>
				</div>
				<div>
					<p class="text-justify white--text">
						شما می توانید پس از ثبت نام و ورود به نرم افزار از درون نرم افزار اقدام به خرید و شارژ آنلاین پلن مورد نظر خود کنید.
						<br />
						در صورت تمایل به خرید و راه اندازی بر روی هاست و دامنه اختصاصی از طریق فرم درخواست مشاوره، درخواست خود را ثبت نمایید و یا با ما در تماس باشید.
					</p>
				</div>
			</div>
		</v-sheet>

		<v-sheet class="my-10">
			<v-card class="mx-auto mt-10">
				<div class="mb-10">
					<h3 class="orange--text text--darken-3 ff-emkan-bold fs-h3 text-center">نظر کاربران</h3>
					<div class="text-center orange--text">نظر برخی از کاربران درباره جت اقساط</div>
				</div>
				<v-carousel dark height="300" hide-delimiter-background hide-delimiter>
					<v-carousel-item>
						<v-sheet color="white" height="200" tile>
							<v-row class="fill-height">
								<v-col align="center" justify="center">
									<v-btn fab color="#eee" elevation="1" x-large class="mb-2">
										<v-icon color="#ccc" size="87">mdi-face-man</v-icon>
									</v-btn>
									<div class="text-h5 grey--text mb-3">
										فروشگاه موبایل زندی
									</div>
									<p class="grey--text text--darken-2" style="padding: 0 100px">
										خیلی وقت بود دنبال یه نرم افزار برای مدیریت اقساط مشتریان مان بودیم که جت اقساط بخوبی توانسته در این امر مارو یاری بده.
									</p>
								</v-col>
							</v-row>
						</v-sheet>
					</v-carousel-item>
					<v-carousel-item>
						<v-sheet color="white" height="200" tile>
							<v-row class="fill-height">
								<v-col align="center" justify="center">
									<v-btn fab color="#eee" elevation="1" x-large class="mb-2">
										<v-icon color="#ccc" size="87">mdi-face-man</v-icon>
									</v-btn>
									<div class="text-h5 grey--text mb-3">
										گالری جواهر آویژه
									</div>
									<p class="grey--text text--darken-2" style="padding: 0 100px">
										مشاهده مبلغ آنی تسویه که محاسبه دیرکرد و زودکرد ها رو به صورت خودکار انجام میده جز نقاط قوت نرم افزار هست.
									</p>
								</v-col>
							</v-row>
						</v-sheet>
					</v-carousel-item>
					<v-carousel-item>
						<v-sheet color="white" height="200" tile>
							<v-row class="fill-height">
								<v-col align="center" justify="center">
									<v-btn fab color="#eee" elevation="1" x-large class="mb-2">
										<v-icon color="#ccc" size="87">mdi-face-woman</v-icon>
									</v-btn>
									<div class="text-h5 grey--text mb-3">
										فروشگاه لوازم خانگی اولیائی
									</div>
									<p class="grey--text text--darken-2" style="padding: 0 100px">
										از مجموعه تولید کننده این نرم افزار و پشتیبانی خوبتون کمال تشکر رو داریم، براتون آرزوی موفقیت روزافزون داریم.
									</p>
								</v-col>
							</v-row>
						</v-sheet>
					</v-carousel-item>
				</v-carousel>
			</v-card>
		</v-sheet>
	</v-container>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import router from '@/router'
	import { setCookie, getCookie } from '@/util/helpers'

	export default {
		name: 'HomeView',
		components: {
			Countdown: () => import('@/components/Countdown'),
		},
		data: () => ({
			errorMessages: '',
			reg: { name: '', mobile: '' },
			loading: false,
			regLoading: false,
			regValidation: '',
			sendCodeVisible: true,
			showLoginToAppBtn: false
		}),
		computed: {
			...get('auth', [
				'isAdmin', 'getCurrentUser'
			]),
			...get('siteConfig', [
				'permanentPrice', 'cloudPrice'
			])
		},

		methods: {
			purchase(productType) {
				this.loading = true
				let data = {
					productType: productType,
					paymentMethod: 0
				}
				api.post('admin/purchase/create', data)
					.then(
						response => {
							window.location.replace(response)
						})
					.catch(err => {
						this.loading = false
						toast.error(err.message)
					})

			},
			submitRegister() {
				if (!this.$refs.registerForm.validate()) { return }
				this.regValidation = ''
				this.regLoading = true

				const formData = new FormData()
				formData.append('name', this.reg.name)
				formData.append('mobile', this.fixPhoneNumber(this.reg.mobile))
				formData.append('sendSms', true)
				const affCode = getCookie('aff')
				if (affCode) {
					formData.append('affCode', affCode)
				}
				api.post('account/register', formData, { authHeader: false, contentType: 'multipart/form-data' })
					.then(response => {
						this.$refs.countdown.start()
						this.sendCodeVisible = false
						this.showLoginToAppBtn = true
					})
					.catch(err => {
						this.regValidation = err.message
					})
					.finally(() => {
						this.regLoading = false
					})

			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			isPhoneNumberValid() {
				return this.reg.mobile && (/^((?!(0))[0-9]{10})$/g.test(this.reg.mobile) || /^0[0-9]\d{9}$/g.test(this.reg.mobile))
			},
			loginToApp() {
				router.push({ name: 'Login' })
			},
			fixPhoneNumber(number) {
				if (number?.length == 10 && !number.startsWith('0'))
					number = '0' + number
				return number
			}
		},
	}
</script>

<style lang="scss">
	.landing {
		.fs-h1 {
			font-size: 3.3125rem !important;
		}

		.fs-h2 {
			font-size: 2.25rem !important;
		}

		.fs-h3 {
			font-size: 1.5625rem !important;
		}

		.fs-h4 {
			font-size: 1.125rem !important;
		}

		.fs-h5 {
			font-size: 1.0625rem !important;
		}

		.fs-h6 {
			font-size: 0.75rem !important;
		}

		.fs-subtitle-1 {
			font-size: 0.875rem !important;
		}

		.fs-subtitle-2 {
			font-size: 0.875rem !important;
		}

		.fs-caption {
			font-size: 0.8125rem !important;
		}
	}

	.section-title {
		position: relative;
		margin-right: 38px;

		&:before {
			position: absolute;
			bottom: 5px;
			right: -40px;
			content: "";
			width: 30px;
			height: 60px;
			background-image: radial-gradient(#bbb 2px, transparent 2px);
			-webkit-background-size: 20px 20px;
			background-size: 10px 10px;
			border-radius: 0px;
			background-repeat: initial;
		}
	}

	.line-title {
		position: relative;
		display: flex;

		.line {
			position: relative;
			flex-grow: 2;

			&:after {
				position: absolute;
				content: " ";
				background-color: #ffffff3d;
				height: 2px;
				right: 0;
				left: 0;
				top: 25px;
			}
		}

		.text {
			padding-left: 20px;
			font-size: 2.25rem !important;
			color: orange;
			font-family: "Emkan-Bold", "Yekan", "tahoma";
		}

		&:after {
			height: 2px;
			width: 50px;
			content: "";
			position: absolute;
			left: 0;
			height: 2px;
			top: 46%;
			background-color: orange;
		}
	}

	.price-table {
		background-color: #f1f1f1;
		position: relative;

		.price-table__ribbon {
			position: absolute;
			top: 0;
			left: 0;
			right: auto;
			-webkit-transform: rotate(0);
			-ms-transform: rotate(0);
			transform: rotate(0);
			width: 150px;
			overflow: hidden;
			height: 150px;

			.price-table__ribbon-inner {
				background-color: orange;
				color: #ffffff;
				font-weight: 500;
				text-align: center;
				left: 0;
				width: 200%;
				-webkit-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				-ms-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				margin-top: 35px;
				font-size: 13px;
				line-height: 2;
			}
		}

		.header {
			background-color: #4d306e;
			text-align: center;
			padding: 20px;

			.title-1 {
				font-size: 1.4rem;
				font-weight: bold;
				color: white;
			}

			.title-2 {
				font-size: 0.9rem;
				color: white;
			}
		}

		.price {
			padding: 15px;
			// font-family: "Emkan-Bold", "Yekan", "tahoma";
			font-size: 3rem;
			text-align: center;

			.currency {
				font-size: 1rem;
			}
		}

		.features {
			margin: 0 50px;

			.features-item {
				display: flex;
				padding: 10px;
				border-bottom: 1px solid rgba(122, 122, 122, 0.298);
				color: #7a7a7a;
				font-size: 0.9rem;
			}
		}
	}
</style>